import React from 'react';
import { NavLink } from 'react-router-dom';
import './Footer.css';

// ── ALL FOOTER CONTENT IN ONE PLACE ──────────────────────────
const FOOTER_DATA = {
  logo: {
    img: '/Images/willtowealth.png',
    name: 'Will to Wealth',
    // sub: 'Financial Group',
    linkTo: '/home',
  },

  tagline: {
    main: 'Turning Dreams Into Financial Freedom',
    // sub: 'Creating Wealth For Families Across North America',
  },

  whatsapp: {
    number: '19173466654',
    label: 'Message us on WhatsApp',
  },

  contact: {
    link: {
      url: 'https://bit.ly/2Z6BE07',
      label: 'bit.ly/2Z6BE07',
    },
    phone: '+19173466654',
    email: 'info@willtowealth.com',
  },

  navLinks: [
    { label: 'Home', to: '/home' },
    { label: 'About Us', to: '/aboutus' },
    { label: 'Our Services', to: '/services' },
    { label: 'Consultation', to: '/consultation' },
    { label: 'Blog', to: '/blog' },
  ],

  legal: {
    year: new Date().getFullYear(),
    company: 'Will to Wealth Financial Group',
    termsUrl: 'https://hgicrusade.com/terms-and-conditions',
    privacyUrl: 'https://hgicrusade.com/privacy-policy',
  },
};

// ── FOOTER COMPONENT ─────────────────────────────────────────
function Footer() {
  const { logo, tagline, whatsapp, contact, navLinks, legal } = FOOTER_DATA;

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-top-inner">
          <NavLink to={logo.linkTo} className="footer-logo" onClick={scrollToTop}>
            <img
              src={logo.img}
              alt={`${logo.name} logo`}
              className="footer-logo-img"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <div className="footer-logo-text">
              <span className="footer-logo-name">{logo.name}</span>
              <span className="footer-logo-sub">{logo.sub}</span>
            </div>
          </NavLink>

          <div className="footer-tagline">
            <div className="footer-tagline-main">{tagline.main}</div>
            <div className="footer-tagline-sub">{tagline.sub}</div>
          </div>

          <a
            href={`https://wa.me/${whatsapp.number}`}
            target="_blank"
            rel="noreferrer"
            className="footer-whatsapp"
          >
            <span className="footer-whatsapp-icon">💬</span>
            {whatsapp.label}
          </a>
        </div>
      </div>

      <div className="footer-contact-band">
        <div className="footer-contact-inner">
          <span className="footer-contact-label">Contact Us:</span>

          <div className="footer-contact-divider" />

          <div className="footer-contact-item">
            <span className="footer-contact-icon">🔗</span>
            <a href={contact.link.url} target="_blank" rel="noreferrer">
              {contact.link.label}
            </a>
          </div>

          <div className="footer-contact-divider" />

          <div className="footer-contact-item">
            <span className="footer-contact-icon">📞</span>
            <a href={`tel:${contact.phone.replace(/-/g, '')}`}>
              Office: {contact.phone}
            </a>
          </div>

          <div className="footer-contact-divider" />

          <div className="footer-contact-item">
            <span className="footer-contact-icon">✉️</span>
            <a href={`mailto:${contact.email}`}>
              {contact.email}
            </a>
          </div>
        </div>
      </div>

      <div className="footer-nav-band">
        <nav className="footer-nav-inner">
          {navLinks.map((link, index) => (
            <React.Fragment key={link.to}>
              <NavLink
                to={link.to}
                className="footer-nav-link"
                onClick={scrollToTop}
              >
                {link.label}
              </NavLink>

              {index < navLinks.length - 1 && (
                <span className="footer-nav-dot" aria-hidden="true">
                  •
                </span>
              )}
            </React.Fragment>
          ))}
        </nav>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-inner">
          <span className="footer-copyright">
            © {legal.year} {legal.company}
          </span>

          <span className="footer-bottom-pipe" aria-hidden="true">
            |
          </span>

          <a
            href={legal.termsUrl}
            target="_blank"
            rel="noreferrer"
            className="footer-legal-link"
          >
            Terms of Service
          </a>

          <span className="footer-bottom-pipe" aria-hidden="true">
            |
          </span>

          <a
            href={legal.privacyUrl}
            target="_blank"
            rel="noreferrer"
            className="footer-legal-link"
          >
            Privacy Policy
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;